<template>
  <ul class="tab">
    <li
      v-for="({ title, url }, index) in list"
      :key="index"
      @click="$router.push(url)"
      :class="{ active: $route.path == url }"
    >
      {{ title }}
    </li>
  </ul>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  name: 'ActivityTab',
  data() {
    return {
      list: [
        { title: '任务数据', url: '/home/activity/record/taskData' },
        { title: '用户数据', url: '/home/activity/record/userData' },
        { title: '数据统计', url: '/home/activity/record/statistics' },
      ],
    }
  },

  methods: {},
  computed: {},
}
</script>

<style lang="less" scoped>
.tab {
  display: flex;
  list-style: none;
  gap: 16px;
  padding: 0;
  li {
    cursor: pointer;
    &:hover {
      color: #707aff;
    }
  }
  .active {
    color: #707aff;
  }
}
</style>
